// removed by extract-text-webpack-plugin
module.exports = {"input":"_2OXgF2w7bhFvZz6lLCyKcz"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/IncomingDelivery/style.scss
// module id = 1258
// module chunks = 0